import Toast, { ToastTypes } from 'components/ToastNotify';
import { RedeemCustomerLoyaltyPoints } from 'firebaseApis/contacts';
import React from 'react';
import { useDispatch } from 'react-redux';
import { hideLoading, showLoading } from 'reducers/Alerts/AlertActions';
import Button from 'storybook-mui/build/components/Button';
import Modal from 'storybook-mui/build/components/Modal';
import NumberField from 'storybook-mui/build/components/NumberField';
import TextAreaField from 'storybook-mui/build/components/MuiTextArea';

function RedeemPointsModal({
	showRedeemPointsModal,
	setShowRedeemPointsModal,
	customer,
	getData = () => {},
}: IRedeemPointsModalProps) {
	const [pointsToRedeem, setPointsToRedeem] = React.useState(10);
	const [notes = '', setNotes] = React.useState('');
	const dispatch: any = useDispatch();
	const redeemPoints = async () => {
		try {
			dispatch(showLoading())
			const response = await RedeemCustomerLoyaltyPoints(customer, pointsToRedeem  , notes);
			if (response.success) {
				Toast({ type: ToastTypes.SUCCESS, title: 'Points redeemed successfully' });
				getData();
				setShowRedeemPointsModal(false);
			} else {
				Toast({ type: ToastTypes.ERROR, title: 'Internal Error' });
			}
			dispatch(hideLoading())
		} catch (error) {
			Toast({ type: ToastTypes.ERROR, title: 'Error redeeming points' });
			dispatch(hideLoading());
		}
	};

	return (
		<Modal
			title='Redeem Loyalty Points'
			content={
				<>
					<div className='flex flex-col gap-3'>
						<div className='font-semibold bg-info-200 p-5 rounded'>
							<h1>
								Customer Name : {customer?.First_Name} {customer?.Last_Name}
							</h1>
							<h1>Avaiable Points : {customer?.PosLoyaltyPoints?.Available}</h1>
						</div>
						<NumberField
							name='points'
							fieldId='points'
							onChange={(e) => setPointsToRedeem(e.target.value)}
							value={pointsToRedeem}
							labelName='Points'
							placeholder='Enter Points'
							max={customer?.PosLoyaltyPoints?.Available}
						/>
						<TextAreaField
							name='Notes'
							fieldId='Notes'
							onChange={(e) => {
								setNotes(e.target.value);
							}}
							value={notes}
							placeholder='Enter Notes'
							labelName='Notes'
						/>
						{customer?.PosLoyaltyPoints?.Available < pointsToRedeem && (
							<p className='bg-error p-5 rounded'>
								Points to redeem must be less than available points
							</p>
						)}
						<div className='flex justify-end gap-5'>
							<Button
								title='Close'
								onClick={() => setShowRedeemPointsModal(!showRedeemPointsModal)}
								variant='outlined'
								color='info'
							/>
							<Button
								title='Redeem'
								onClick={() => redeemPoints()}
								variant='contained'
								color='info'
								disabled={customer?.PosLoyaltyPoints?.Available < pointsToRedeem}
							/>
						</div>
					</div>
				</>
			}
			modalId='customerOrders'
			open={showRedeemPointsModal}
			setOpen={() => setShowRedeemPointsModal(false)}
			closeIcon
			size='sm'
		/>
	);
}

export default RedeemPointsModal;

export interface IRedeemPointsModalProps {
	showRedeemPointsModal: boolean;
	setShowRedeemPointsModal: (value: boolean) => void;
	customer: any;
	getData: () => void;
}